export interface IDashMicrositeRecipientSummary {
    
}